import { render, staticRenderFns } from "./unsub-btn.component.vue?vue&type=template&id=d6e4502a&scoped=true"
import script from "./unsub-btn.component.vue?vue&type=script&lang=js"
export * from "./unsub-btn.component.vue?vue&type=script&lang=js"
import style0 from "./unsub-btn.component.vue?vue&type=style&index=0&id=d6e4502a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e4502a",
  null
  
)

export default component.exports